import { render, staticRenderFns } from "./false-model.vue?vue&type=template&id=4e06559e&scoped=true&"
import script from "./false-model.vue?vue&type=script&lang=js&"
export * from "./false-model.vue?vue&type=script&lang=js&"
import style0 from "./false-model.vue?vue&type=style&index=0&id=4e06559e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e06559e",
  null
  
)

export default component.exports